<template>
  <contents-box
    type="inner"
    :class="$style.intake_box">
    <ul>
      <li :class="$style.row">
        <label-box label="受付日時" color="gray" size="sm" :class="$style.intake_box_label" />
        <p :class="$style.content">{{ filterMoment(group.created_at, 'YYYY年MM月DD日 HH:mm') }}</p>
      </li>
      <li v-if="types.length" :class="$style.row">
        <label-box label="お悩み" color="gray" size="sm" :class="$style.intake_box_label" />
        <div :class="[$style.value, $style.type, hasSubTypesRecorded(group) ? $style.typeCompany : '']">
          <p
            class="n2br"
            v-for="item in types"
            :key="item">{{ getWorryTypeLabel(item, isCompanyEffective, 'texts') }}<span v-if="showOtherText && item === 6 && group.other_text">（{{ group.other_text }}）</span>
            <span v-if="getWorrySelectedSubText(item, getRecordedSubs(group, item), isCorporateEffective, 'texts')" :class="$style.subList">{{ getWorrySelectedSubText(item, getRecordedSubs(group, item), isCorporateEffective, 'texts') }}</span>
          </p>
        </div>
      </li>
      <!-- 回答期限は Hook が担当曜日行のある相談にだけ limit を付ける。無い相談は行ごと出さない -->
      <li v-if="showReplyDeadline && !group.done && group.limit" :class="$style.row">
        <label-box label="回答期限" color="gray" size="sm" :class="$style.intake_box_label" />
        <p :class="[$style.content, $style.limitStatus]">
          <span
            :style="`background: ${getLimitAlert(group.limit).color}`"
            :class="$style.circleStatus"
            v-if="getLimitAlert(group.limit).color"></span>
          <b>{{ filterMoment(group.limit, 'YYYY年MM月DD日') }}<b v-if="getLimitAlert(group.limit).label">（{{ getLimitAlert(group.limit).label }}）</b></b>
        </p>
      </li>
      <li v-if="showHistory && historyGroups.length" :class="$style.row">
        <label-box label="相談履歴" color="gray" size="sm" :class="$style.intake_box_label" />
        <div :class="$style.content">
          <div :class="$style.who5_top">
            <b>{{ historyGroups.length }}件</b>
            <div :class="$style.plus" @click="flag.history = !flag.history">
              <i v-if="flag.history" class="fa-solid fa-minus"></i>
              <i v-else class="fa-solid fa-plus"></i>
            </div>
          </div>
          <ul v-if="flag.history" :class="$style.btns">
            <li
              :class="$style.btn"
              v-for="row in historyGroups"
              :key="row.id">
              <a
                :href="`/operator/reserve/text/${row.id}/`"
                target="_blank">{{ filterMoment(row.created_at, 'M/D') }}
                <span v-for="gType in historyTypesOf(row)" :key="gType">{{ getWorryTypeLabel(gType, isCompanyEffective, 'texts') }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <!--
        WHO-5 の回答レコードが実在し、かつ点数が算出できている相談だけココモニを出す。
        scoreWho5 は Hook が未回答でも 0 を返すので、点数だけでは「0点」行を常時描画してしまう。
        who5Answer 単独だと Hook が early return した行で点数が空欄になる。両方を条件にする（Histories と同じ）。
      -->
      <li v-if="group.who5Answer && group.scoreWho5 >= 0" :class="$style.row">
        <label-box label="ココモニ" color="gray" size="sm" :class="$style.intake_box_label" />
        <div :class="$style.content">
          <div :class="$style.who5_top">
            <p :class="$style.who5_score">
              <span :class="$style.who5_score_label">ココモニチェック</span>{{ group.scoreWho5 }}点
            </p>
            <div :class="$style.open" @click="flag.who5 = !flag.who5">
              <p v-if="!flag.who5">詳細を表示<i class="fa-solid fa-angles-down"/></p>
              <p v-else>詳細を非表示<i class="fa-solid fa-angles-up"/></p>
            </div>
          </div>
          <ul v-if="flag.who5 && Array.isArray(group.who5Answer.answers)" :class="$style.who5_detail_list">
            <li v-for="(item, i) in helper.master.who5.items" :key="i">
              <p :class="$style.who5_label">{{ item.label }}</p>
              <p :class="$style.who5_answer">{{ helper.master.who5.labels[group.who5Answer.answers[i]] }}</p>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </contents-box>
</template>

<script>
/**
 * 受付中・下書きのテキスト健康相談 1 件を、アカウント詳細の「テキスト受付」ブロックとして描画する。
 * データは /v1/messagegroup/get/list の 1 行（type 配列化・who5Answer.answers パース済み・Hook の limit/done/scoreWho5 付き）。
 *
 * 回答期限・相談履歴・お悩み「その他」の自由記述は、親が prop で opt-in したときだけ出す。
 * 学校・企業の管理者（11/12）にはこれらを出さない現行の開示範囲（顧客裁定）を、
 * 「渡し忘れが『出さない』側に倒れる」形で守る（既定 false・管理サイトは何も渡さない・事務局は 3 つとも true）。
 * 相談本文と推移グラフは事務局にも出さない（このブロックの図に無い。事務局はテキスト相談タブで読める）。
 */
import { mapState } from 'vuex';
import ContentsBox from '@/views/components/ContentsBox.vue';
import LabelBox from '@/views/components/LabelBox.vue';

import cf from '@/mixins/commonFunctions.js';
import corporateSchool from '@/mixins/corporateSchool.js';
import consultationBlocks from '@/mixins/consultationBlocks.js';

export default {
  name: 'text-intake-box',
  mixins: [cf, corporateSchool, consultationBlocks],
  components: {
    ContentsBox,
    LabelBox,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    // 回答期限（Hook の limit と締切ラベル）を出すか。事務局向けのみ true
    showReplyDeadline: {
      type: Boolean,
      default: false,
    },
    // 相談履歴 N 件（開くと一覧・事務局のテキスト相談詳細へのリンク）を出すか。事務局向けのみ true
    showHistory: {
      type: Boolean,
      default: false,
    },
    // お悩み「その他」の自由記述を出すか。事務局向けのみ true
    showOtherText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      flag: {
        history: false,
        who5: false,
      },
    };
  },
  computed: {
    ...mapState(['helper']),
    // 大項目はチェック順で保存されるため、表示順をマスタ番号昇順へ正す
    types() {
      return this.sortWorryTypes(this.worryTypesOf(this.group.type));
    },
    // お悩みラベルの企業/学校バリアント判定。get() が customer.school を無条件 eager-load するので自己判定できる
    // （親から isCompany を渡さない。渡す形にすると管理サイト側の判定 computed と結合する）
    isCompanyEffective() {
      return !!this.group?.customer?.school?.[0]?.is_company;
    },
    // 企業固有のお悩みサブ項目ゲート。企業（is_company かつ is_corporate）のときだけ true・インターンでは出さない
    isCorporateEffective() {
      return this.isCorporateSchool(this.group?.customer?.school);
    },
    // 相談履歴チップの並び。customer.messageGroups は eager-load に ORDER BY が無く到着順が実行計画依存なので、
    // ブロック本体と同じ「受付日時の早い順（同時刻は id・欠損は末尾）」に画面側で正す。元配列は変えない
    historyGroups() {
      return this.sortTextIntakes(this.group?.customer?.messageGroups);
    },
  },
  methods: {
    // 相談履歴の各行は counseling_types の行がそのまま（type.type が JSON 文字列）なので 3 形対応の取り出しを通す
    historyTypesOf(row) {
      return this.sortWorryTypes(this.worryTypesOf(row.type));
    },
  },
};
</script>

<style lang="scss" module>
// 全部 .intake_box 配下にネストする（裸の li / dt は document 全体へ漏れる）。
// 行は bare の li でなく .row で指定し、内側の一覧（相談履歴のチップ・ココモニの 5 問）へ
// 行用の flex / 余白が子孫セレクタ経由で降りないようにする。
.intake_box {
  width: 100%;
  margin-bottom: .5rem;
  .row {
    display: flex;
    align-items: flex-start;
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
  .content {
    margin-top: 3px;
    flex: 1;
    word-break: break-all;
  }
  .intake_box_label {
    min-width: 6rem;
    max-width: 6rem;
    margin-right: 0.5rem;
  }
  .value {
    flex: 1;
    margin-top: 3px;
    &.type {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      p {
        &:not(:last-child) {
          &::after {
            margin: 0 5px;
            content: '/';
          }
        }
        // 「その他」自由記述などで長い半角英字連続が来た時の折り返し
        > span {
          word-break: break-all;
          overflow-wrap: break-word;
          font-weight: normal;
        }
      }
    }
    // 企業ユーザー時のみ、メイン項目を縦並びにしてセパレータを消す
    &.typeCompany {
      display: block;
      p:not(:last-child)::after {
        content: '';
        margin: 0;
      }
    }
  }
  .limitStatus {
    display: flex;
    align-items: center;
    .circleStatus {
      $size: 1.2em;
      margin-right: .5rem;
      width: $size;
      height: $size;
      border: 1px solid #ddd;
      border-radius: 100%;
      overflow: hidden;
    }
  }
  .who5_top {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .who5_score {
    margin-right: 16px;
    &_label {
      margin-right: 12px;
    }
  }
  // 「＋/−」は「n件」の右隣に置く（件数と開閉の連動を見せる）。12px だと 20px のアイコン余白と合わさって離れて見えた。
  // 6px ≒ 本文 14px の 0.5em。Histories.vue の同名 .plus とは別定義（あちらは触らない）
  .plus {
    margin-left: 6px;
    font-size: 20px;
    color: var(--gray-main);
    cursor: pointer;
  }
  .open {
    color: var(--gray-side);
    font-size: 14px;
    cursor: pointer;
    p {
      display: flex;
      align-items: center;
    }
    i {
      margin-left: 4px;
    }
    &:hover {
      opacity: .7;
    }
  }
  .btns {
    display: flex;
    flex-wrap: wrap;
    li {
      white-space: nowrap;
      a {
        color: var(--black);
      }
    }
    // チップの余白は .btn（(0,3,0)）で指定する。事務局では .detail li:not(:last-child) { margin-bottom: 15px }（(0,2,1)）が
    // 子孫として降りてくるので、li（(0,2,1)＝同詳細度・順序依存）でなく詳細度を 1 段上げて順序に関係なく勝たせる
    .btn {
      margin: 8px 10px 0 0;
      padding: 4px 12px;
      border-radius: 4px;
      background-color: var(--gray-sub);
    }
  }
  .who5_detail_list {
    margin-top: 8px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
    .who5_answer {
      margin-left: 12px;
      font-weight: bold;
      white-space: nowrap;
    }
  }
  // 狭幅でもラベルは上書きしない。ReserveInfoBox の sm-view にある `.label { width:100%; padding:.5em … }` は
  // 当てる要素が無い dead 宣言で、予約側のラベルは狭幅でも 6rem 固定のチップのまま。ここへ写すと live 化して
  // 「テキスト受付」だけ幅いっぱいの帯になり、同じ欄に並ぶ 2 ブロックの体裁が割れる（実測: 375px で 271px vs 96px）。
  @include sm-view {
    font-size: 14px;
    .row {
      display: block;
      &:not(:first-child) {
        margin-top: 1.4em;
      }
    }
  }
}
// 企業サイト: メイン項目の下に「選択済み」サブ項目を ' / ' 連結で表示する（ReserveInfoBox と同形）。
// span を block 化して親 <p> 内で改行させる。テンプレ側は 1 行で書くこと。
.subList {
  display: block;
  margin: 2px 0 8px 20px;
  font-size: 13px;
  color: #555;
}
</style>
